import { useAuth } from './AuthContext';

export function usePermission() {
  const { permissions, isSuperAdmin } = useAuth();

  // `perm` may be a single permission name or an array of names, any one of which is enough
  // (e.g. a route/nav entry gated on ['leads.view-own', 'leads.view-all']).
  const can = (perm) => {
    if (!perm) return true;
    if (Array.isArray(perm)) return isSuperAdmin || perm.some((p) => permissions.has(p));
    return isSuperAdmin || permissions.has(perm);
  };
  const canAny = (perms) => isSuperAdmin || perms.some((p) => permissions.has(p));

  return { can, canAny };
}
